import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';
import type { HouseholdChatPromptTemplate } from '@/types/schema';

/**
 * Deep-link param that opens the household agent on a specific conversation.
 * The chat provider is only mounted on household pages, and only ever for the
 * household in view, so opening a conversation in a *different* household has
 * to travel through the URL rather than a direct context call.
 */
export const OPEN_CHAT_CONVERSATION_ID_QUERY_PARAM = 'chatConversationId';

export interface HouseholdChatNavigationState {
  initialHouseholdChatMessage?: {
    message: string;
    withPromptTemplate?: HouseholdChatPromptTemplate;
    workflowTrackerQueryParam?: string;
  };
}

/** Path to a household's overview with the chat opened on `conversationId`. */
export function getOpenChatConversationPath(
  householdId: string,
  conversationId: string
): string {
  return getCompletePathFromRouteKey(
    ROUTE_KEYS.HOUSEHOLD_DETAILS_OVERVIEW,
    { householdId },
    { [OPEN_CHAT_CONVERSATION_ID_QUERY_PARAM]: conversationId }
  );
}
